export const BIG_PRIZE_TREE_TYPE_GIDS = [8, 20, 21, 27]
